import { render, staticRenderFns } from "./CreateCustomerProductContractsPopUp.vue?vue&type=template&id=1444a620&scoped=true&"
import script from "./CreateCustomerProductContractsPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateCustomerProductContractsPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateCustomerProductContractsPopUp.vue?vue&type=style&index=0&id=1444a620&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1444a620",
  null
  
)

export default component.exports